import React from "react"

const SearchReset = ({ resetClick, resetSearchText }) => {
  return (
    <button
      className="luna-nav-search__reset-text"
      onClick={resetClick}
      aria-label="Reset search"
    >
      {resetSearchText}
    </button>
  )
}

export default SearchReset
